import { useRef, useState } from 'react';

import { useSortable } from '@dnd-kit/react/sortable';

import type { BuildQuizzesProps } from './BuildQuizzesAnswers';
import BuildQuizzesQuestionCard from './BuildQuizzesQuestionCard';

interface SortableQuestionCardProps extends BuildQuizzesProps {
  isCollapsed: boolean;
  isAnyDragActive: boolean;
  isDropTarget: boolean;
  questionId: string;
}

const SortableQuestionCard = ({
  isCollapsed,
  isAnyDragActive,
  isDropTarget,
  questionId,
  questionIndex,
  ...cardProps
}: SortableQuestionCardProps) => {
  const [element, setElement] = useState<Element | null>(null);
  const handleRef = useRef<HTMLElement | null>(null);
  const { isDragSource } = useSortable({
    id: questionId,
    index: questionIndex,
    element,
    handle: handleRef,
  });

  return (
    <div data-question-id={questionId} ref={setElement}>
      <BuildQuizzesQuestionCard
        {...cardProps}
        handleRef={handleRef}
        isDragSource={isDragSource}
        isCollapsed={isCollapsed}
        isAnyDragActive={isAnyDragActive}
        isDropTarget={isDropTarget}
        questionIndex={questionIndex}
      />
    </div>
  );
};

export default SortableQuestionCard;
